import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusIcon } from './StowageStatusIcon.styles';
import { StowageRuleViolationStatus } from 'src/enums/stowage/stowageRule/stowageRuleViolationStatus';

export const ViolationStatusIcon = (status: StowageRuleViolationStatus) => {
    switch (status) {
        case StowageRuleViolationStatus.NotApplicable:
            return;
        case StowageRuleViolationStatus.New: {
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="New violation" />
                </StatusIcon>
            );
        }

        case StowageRuleViolationStatus.Accepted:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Accepted violation" />
                </StatusIcon>
            );
    }
};

export default ViolationStatusIcon;
